import type { AtomModel } from '@models/atom.model';

import type { TableEditorBooleanColumnData } from '@stratumn/studio-shared';

type Props = {
  atom: AtomModel<TableEditorBooleanColumnData>;
};

export const BooleanSettingsModal = ({ atom }: Props) => {
  atom;
  return <></>;
};
